import { types, getRoot } from "mobx-state-tree";
import { db } from "../firebase.js";
import { actions } from "./_common.js";
import * as dateFns from "date-fns";

export const fieldOptions = types.model({
  value: types.maybeNull(types.string)
});

const refSurveys = db.collection("surveys");

export const AnswerStore = types.compose(
  types
    .model({
      tempAnswerValues: types.optional(
        types.map(types.union(types.string, types.array(types.string))),
        {}
      ),
      status: types.optional(types.string, "pending")
    })
    .actions(self => ({
      setTempAnswerValue: function (e, question) {
        const validation = getRoot(self).$validation.validate(e.target);
        if (Object.keys(validation).length === 0 && getRoot(self).$router.mode === "view") {
          const surveyKey = getRoot(self).$survey.selected._key;
          const questionKey = question._key;
          question.disableOtherQuestionFromLogic(e.target.value, questionKey);
          let value = e.target.value;
          if (e.target.multiple) {
            value = self.tempAnswerValues.get(questionKey);
            if (!value) value = [];
            const index = value.findIndex(elm => elm === e.target.value);
            if (index > -1) {
              value.splice(index, 1);
            } else {
              value.push(e.target.value);
            }
          }
          self.tempAnswerValues.set(questionKey, value);
          localStorage.setItem(
            "barometer-answers-" + surveyKey,
            JSON.stringify(self.tempAnswerValues.toJSON())
          );
        }
      },
      saveTempAnswerValues() {
        const { $user, $router, $survey } = getRoot(self);
        let respondentRef = refSurveys
          .doc($survey.selected._key)
          .collection("respondents")
          .doc(dateFns.format(Date.now(), "ddMMyyHHmm") + "_" + $user.sessionUser.uid);

        let respondent = {
          createdOn: new Date(),
          groupKey: $router.getURLParameterByName("group"),
          createdBy: ($user.sessionUser && $user.sessionUser.uid) || Date.now(),
          answers: self.tempAnswerValues.toJSON()
        };
        console.log(respondent);
        return respondentRef.set(respondent);
      }
    })),
  actions
);
